import { SET_WHATSNEXT_HD } from "../actionTypes";

const initialState = "What happens now?";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_WHATSNEXT_HD: {
      return action.payload;
    }
    default:
      return state;
  }
};
